import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal2);

const AdminPanelUsers = (props) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTaskTypes = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchTaskTypes();
  };

  useEffect(() => {
    getData();
  }, []);

  const changeRights = async (e) => {
    var value = +e.target.value === 1 ? "0" : "1";
    var field = e.target.attributes.field.value;
    var userId = e.target.attributes.fieldUID.value;

    var body = {
      field: field,
      value: value,
      id: userId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/updateUsersTable", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const changeRightsText = (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;

    MySwal.fire({
      title: "Wprowadź nową wartość",
      text: e.currentTarget.attributes.desc.value,
      input: "text",
      inputPlaceholder: e.currentTarget.value,
      inputValue: e.currentTarget.value,
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz podać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;

        var body = {
          field: field,
          value: value,
          id: userId,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeRightsRole = async (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;

    var model = [];
    model["user"] = "user";
    model["admin"] = "admin";

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body = {
          field: field,
          value: result.value,
          id: userId,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeRightsTeam1 = async (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;

    var model = [];
    model["1"] = "1";
    model["2"] = "2";
    model["1,2"] = "1,2";

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body = {
          field: field,
          value: result.value,
          id: userId,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeRightsTeam2 = async (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;

    var model = [];
    model["1"] = "1";
    model["2"] = "2";

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body = {
          field: field,
          value: result.value,
          id: userId,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const usersTableFirst = (
    <table id="detailClientTable" className="clients_table">
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>
        <th>Prawa: wyszukiwanie</th>
        <th>Prawa: kalendarz</th>
        <th>Prawa: dodawnia zadań</th>
        <th>Prawa: dodawnia rozpraw</th>
        <th>Prawa: przypisanie osoby do zadania</th>
        <th>Prawa: edycja rozprawy</th>
        <th>Prawa: historia do rozprawy</th>
        <th>Prawa: przypisanie prawnika do rozprawy</th>
        <th>Prawa: uzupełnienie wyniku rozprawy</th>
        <th>Prawa: uzupełnienie uwag do rozprawy</th>
        <th>Prawa: usuwanie rozprawy</th>
        <th>Prawa: dodawanie sprawy</th>
        <th>Prawa: usuwanie sprawy</th>
      </tr>
      {users.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              {el.name}
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.wyszukaj === "1" ? true : false}
                fieldUID={el.id}
                field="wyszukaj"
                value={el.wyszukaj}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.kalendarz === "1" ? true : false}
                fieldUID={el.id}
                field="kalendarz"
                value={el.kalendarz}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zadanieDodawanie === "1" ? true : false}
                fieldUID={el.id}
                field="zadanieDodawanie"
                value={el.zadanieDodawanie}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaDodawanie === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaDodawanie"
                value={el.rozprawaDodawanie}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zadaniePrzypisanieUsera === "1" ? true : false}
                fieldUID={el.id}
                field="zadaniePrzypisanieUsera"
                value={el.zadaniePrzypisanieUsera}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaEdycja === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaEdycja"
                value={el.zadaniePrzypisanieUsera}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaHistoria === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaHistoria"
                value={el.rozprawaHistoria}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaPrawnik === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaPrawnik"
                value={el.rozprawaPrawnik}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaWynik === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaWynik"
                value={el.rozprawaWynik}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaUwagi === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaUwagi"
                value={el.rozprawaUwagi}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaUsun === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaUsun"
                value={el.rozprawaUsun}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.dodajSprawe === "1" ? true : false}
                fieldUID={el.id}
                field="dodajSprawe"
                value={el.dodajSprawe}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.usunSprawe === "1" ? true : false}
                fieldUID={el.id}
                field="usunSprawe"
                value={el.usunSprawe}
                onChange={changeRights}
              />
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  const usersTableSecond = (
    <table id="detailClientTable" className="clients_table">
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>
        <th>Prawa: raporty</th>
        <th>Prawa: zbiorcza akceptacja terminów</th>
        <th>Prawa: płatności</th>
        <th>Prawa: administracja urlopami</th>
        <th>Prawa: urlopy</th>
        <th>Prawa: praca zdalna</th>
        <th>Prawa: ewidencja</th>
        <th>Prawa: akceptacja spraw</th>
        <th>Prawa: zbiorcza akceptacja spraw</th>
        <th>Prawa: historia do zadania</th>
        <th>Prawa: wykonanie zadania</th>
        <th>Prawa: edycja zadania</th>
        <th>Prawa: usuwanie zadania</th>
        <th>Prawa: panel administracyjny</th>
      </tr>
      {users.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              {el.name}
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.raporty === "1" ? true : false}
                fieldUID={el.id}
                field="raporty"
                value={el.raporty}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zbiorczoAkceptacjaTerminow === "1" ? true : false}
                fieldUID={el.id}
                field="zbiorczoAkceptacjaTerminow"
                value={el.zbiorczoAkceptacjaTerminow}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.platnosci === "1" ? true : false}
                fieldUID={el.id}
                field="platnosci"
                value={el.platnosci}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.urlopyAdmin === "1" ? true : false}
                fieldUID={el.id}
                field="urlopyAdmin"
                value={el.urlopyAdmin}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.urlopy === "1" ? true : false}
                fieldUID={el.id}
                field="urlopy"
                value={el.urlopy}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.urlopyZdalna === "1" ? true : false}
                fieldUID={el.id}
                field="urlopyZdalna"
                value={el.urlopyZdalna}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.ewidencja === "1" ? true : false}
                fieldUID={el.id}
                field="ewidencja"
                value={el.ewidencja}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.akceptacjaSprawy === "1" ? true : false}
                fieldUID={el.id}
                field="akceptacjaSprawy"
                value={el.akceptacjaSprawy}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.akceptacjaSprawyZb === "1" ? true : false}
                fieldUID={el.id}
                field="akceptacjaSprawyZb"
                value={el.akceptacjaSprawyZb}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zadanieHistoria === "1" ? true : false}
                fieldUID={el.id}
                field="zadanieHistoria"
                value={el.zadanieHistoria}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zadanieWykonanie === "1" ? true : false}
                fieldUID={el.id}
                field="zadanieWykonanie"
                value={el.zadanieWykonanie}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zadanieEdycja === "1" ? true : false}
                fieldUID={el.id}
                field="zadanieEdycja"
                value={el.zadanieEdycja}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zadanieUsun === "1" ? true : false}
                fieldUID={el.id}
                field="zadanieUsun"
                value={el.zadanieUsun}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.superAdmin === "1" ? true : false}
                fieldUID={el.id}
                field="superAdmin"
                value={el.superAdmin}
                onChange={changeRights}
              />
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  const usersTableThird = (
    <table
      style={{ width: "100%" }}
      id="detailClientTable"
      className="clients_table"
    >
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>
        <th>Adres e-mail</th>
        <th>Login</th>
        <th>Hasło</th>
        <th>Inicjały</th>
        <th>Rola</th>
      </tr>
      {users.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td
              style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
            >
              {el.name}
            </td>
            <td
              style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.mail}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={""}
                    value={el.mail}
                    fieldUID={el.id}
                    field="mail"
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.login}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={""}
                    value={el.login}
                    fieldUID={el.id}
                    field="login"
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.password}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={""}
                    value={el.password}
                    fieldUID={el.id}
                    field="password"
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "15%", textAlign: "center", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.initials}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    value={el.initials}
                    fieldUID={el.id}
                    field="initials"
                    desc={""}
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "15%", textAlign: "center", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.role}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    value={el.role}
                    fieldUID={el.id}
                    field="role"
                    onClick={changeRightsRole}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  const usersTableFourth = (
    <table
      style={{ width: "60%" }}
      id="detailClientTable"
      className="clients_table"
    >
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>
        <th>Uprawnienia do spraw</th>
      </tr>
      {users.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td
              style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
            >
              {el.name}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.allowedClients}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={
                      'wprowadź "all", jeżeli nadajesz uprawnienia do wszystkich spraw, w przeciwnym razie wprowadź ID spraw po przecinku.'
                    }
                    value={el.allowedClients}
                    fieldUID={el.id}
                    field="allowedClients"
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  const insertUser = async (e) => {
    MySwal.fire({
      title: "Wprowadź login",
      text: "po dodaniu użytkownika dodawj wszystkie wymagane do pracy pola",
      input: "text",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz podać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;

        var body = {
          login: value,
        };

        await fetch("https://apidevkppp.ftpeople.pl/insertUser", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  return (
    <>
      <div className="mainContainerPayments">
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <div
              style={{ width: "100%", marginBottom: "1vh" }}
              className="closeBox"
            >
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Dostęp do spraw i zespoły
            </div>
            {usersTableFourth}
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanelUsers;
